import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel
} from "@/components/ui/form"
import { Input } from "@/components/ui/input";
import { Dropdown } from '../ui/filterSelect';

import { set, z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { UserInfoSchema, UserSchema } from "./UserSchema";
import { useEffect, useState } from "react";
import { useApiFetch } from "@/helper/apiFetch";
import { Checkbox } from "../ui/checkbox";
import { useTranslate } from "@/helper/translate";
import { Pencil } from "lucide-react";
type UserInfoProps = {
  user: UserInfoSchema;
  eventId: string|null;
  onClose: (refresh: boolean) => void;
};


type Lookup = { id: string; name: string };


export function UserInfo({ user, eventId, onClose }: UserInfoProps) {
  const apiFetch = useApiFetch();
  const { translate } = useTranslate();
  const [errorText, setError] = useState<string>("");
  const [pwText, setPwText] = useState<string>("");
const[roleEdit, setRoleEdit] = useState<boolean>(false);

  const form = useForm<z.infer<typeof UserSchema>>({
    resolver: zodResolver(UserSchema),
    defaultValues: {
      Id: user.Id,
      UserName: user.UserName,
      FirstName: user.FirstName,
      LastName: user.LastName,
      RoleIdentifier: user.RoleIdentifier,
      AllowTalkrequest: user.AllowTalkrequest
      
    }
  });

  useEffect(() => {
    form.reset({
      Id: user.Id,
      UserName: user.UserName,
      FirstName: user.FirstName,
      LastName: user.LastName,
      RoleIdentifier: user.RoleIdentifier,
      AllowTalkrequest: user.AllowTalkrequest,
    });
    setPwText("");
    setError("");
    setRoleEdit(false);
  }, [form, user]);



  const onSubmit = async (values: z.infer<typeof UserSchema>) => {

    try {
      setError("");
      const url = values.Id ? `/api/EventPool/PutUser` : `/api/EventPool/PostNewUser`;
      const res = await apiFetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      if (!res.ok) {
        const e = await res.text();
        setError(translate("ui.failedsave") + e);

      }
      else {

        onClose(true);

      }
    } catch (err) {
      console.error(err);
    }
  }




 const reset = async () => {

    try {
      setError("");
      const res = await apiFetch(`/api/EventPool/ResetUserPassword?userId=${user.Id}&eventId=${eventId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        }
      });

      if (!res.ok) {
        const e = await res.text();
        setError(translate("ui.failedsave") + e);

      }
      else {

        const p = await res.text();
        setPwText(p);

      }
    } catch (err) {
      console.error(err);
    }
  }



  return (
    <div className="p-5">

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-2">
          <div className="grid-default items-end">
            <FormField
              control={form.control}
              name="UserName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>User Name/Email</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                </FormItem>
              )}
            />
            
{(user.Id == "" ) ? (
  <div className="">
              <FormField
                control={form.control}
                name="Password"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Password</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
              </div>
            ):(
               <div className="">
                {pwText == ""? (
            <Button className="" type="button" onClick={() => {  reset(); }}>{translate("common.reset")}</Button>
                ):(
                  <div>
                    <div className="text-green-500 mb-2">New Password: {pwText}</div>
                  </div>
                )
              }
                </div>
              )
              }
<FormField
                control={form.control}
                name="FirstName"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>First Name</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="LastName"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Last Name</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />

 <FormField
                control={form.control}
                name="AllowTalkrequest"
                render={({ field }) => (
                  <FormItem className="flex items-center space-x-2">
                    <FormControl>
                      <Checkbox
                        label="Allow Talk Request"
                        checked={!!field.value}
                        onCheckedChange={field.onChange}
                        name={field.name}
                        onBlur={field.onBlur}
                        ref={field.ref}
                      />
                    </FormControl>

                  </FormItem>

             
                )}
              />
                {/* <div className="flex items-center gap-2">
                        <span>{form.getValues("RoleIdentifier")}</span>
                        <Button type="button" variant="outline" size="icon" title="Edit role identifier" aria-label="Edit roles" onClick={(e) => setRoleEdit(true)}>
                          <Pencil className="h-4 w-4" aria-hidden="true" />
                        </Button>
                      </div> */}
           
          </div>

          <div className="grid-default grid-cols-4">
            
            <div></div>
            <Button className="w-full" type="button" onClick={() => { console.log("Cancel clicked"); onClose(false); }}>{translate("common.cancel")}</Button>

            <Button className="w-full" type="submit">{translate("common.save")}</Button>
          </div>
          {(errorText != "") && (
            <div className="text-red-500 mt-2">
              {errorText}
            </div>
          )
          }

        </form>
      </Form>
    </div>

  )
}



